import { FC, useState } from 'react';

import { Text, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { AccountForm } from 'components/AccountCreate/components/AccountForm/AccountForm';
import { ConfirmationModal } from 'components/AccountCreate/components/ConfirmationModal';

import { SessionType } from 'store/models/user';
import { useSelector } from 'store/utils';

export const AccountCreate: FC = () => {
    const isSudo = useSelector((state) => state.user.sessionType === SessionType.Sudo);
    const accountId = useSelector((state) => state.accounts.accountId);

    const [isConfirmationModalVisible, setConfirmationModalVisible] = useState(false);

    const trl = useTrls();

    if (!isSudo) {
        return null;
    }

    return (
        <>
            {!accountId && (
                <>
                    <Text typography="paragraph-2-regular">{trl('account.create.description')}</Text>
                    <VSpacing default={24} />
                </>
            )}
            <AccountForm setConfirmationModalVisible={setConfirmationModalVisible} />
            <ConfirmationModal isVisible={isConfirmationModalVisible} setVisible={setConfirmationModalVisible} />
        </>
    );
};
